import AlertArea from "./AlertArea.js";
import global from "../global.js";

const log = global.log.getLogger("f_mtac.ui.InputCoordinatesArea");
log.setLevel(log.levels.WARN);

let InputCoordinatesArea = function () {
    var {Modal} = window.f_mtac_theme;
    var $input_coordinates_area = document.getElementById("input_coordinates_area");
    var $input_longitude = $("#input_coordinates_area .input-longitude input");
    var $input_latitude = $("#input_coordinates_area .input-latitude input");
    var input_coordinates_area_modal;

    let CommaToPoint = (obj) => {
        return obj.replace(/,/g, ".");
    };

    this.interact = function ({E = "", N = ""}) {
        let new_N = "";
        let new_E = "";
        input_coordinates_area_modal = new Modal($input_coordinates_area);

        // Prepare the view
        $("#input_coordinates_area input").attr("pattern", "-{0,1}[0-9]*[\\.,]{0,1}[0-9]*");
        $input_latitude.val(N);
        $input_longitude.val(E);
        $("#input_coordinates_area .invalid-feedback").hide();
        if (E === "" || N === "") {
            $("#input_coordinates_area button[data-method='ok']").attr("disabled", true);
        }

        // User actions handlers
        let handlers = {
            ok: () => {
                new_N = CommaToPoint($input_latitude.val());
                new_E = CommaToPoint($input_longitude.val());
                input_coordinates_area_modal.hide();
            },
            cancel: () => {
                // put E,N to empty so that promise return null value
                new_N = "";
                new_E = "";
                input_coordinates_area_modal.hide();
            },
            position: async () => {
                var position = await global.geolocation.current_position();
                if (position === null) {
                    await AlertArea.interact({
                        type: "danger",
                        tip1: global.internationalization.text("sitac.Geolocation-service-not-available")
                    });
                    return;
                }
                $input_longitude.val(position.coords.longitude);
                $input_latitude.val(position.coords.latitude);
                $("#input_coordinates_area button[data-method='ok']").removeAttr("disabled");
            }
        };

        // Manage events
        $input_coordinates_area.addEventListener("shown.bs.modal", function () {
            $input_latitude.trigger("focus");
            $input_latitude[0].setSelectionRange(0, $input_latitude.val().length);
        });

        $("body").on("click.input_coordinates_area.btn", "#input_coordinates_area .btn", (event) => {
            let method = $(event.currentTarget).data("method");
            log.debug(`${method} pressed.`);
            handlers[method]();
        });

        $("#input_coordinates_area input").on("focus blur keyup paste input", () => {
            if (!$("#input_coordinates_area .input-longitude input")[0].checkValidity()) {
                $("#input_coordinates_area .input-longitude .invalid-feedback").show();
                $("#input_coordinates_area button[data-method='ok']").attr("disabled", true);
                return;
            }
            if (!$("#input_coordinates_area .input-latitude input")[0].checkValidity()) {
                $("#input_coordinates_area .input-latitude .invalid-feedback").show();
                $("#input_coordinates_area button[data-method='ok']").attr("disabled", true);
                return;
            }
            $("#input_coordinates_area button[data-method='ok']").removeAttr("disabled");
            $("#input_coordinates_area .invalid-feedback").hide();
        });

        $("body").on("keydown", "#input_coordinates_area", async (event) => {
            switch (event.key) {
                case "Enter":
                    event.preventDefault();
                    handlers["ok"]();
                    break;
                case "Escape":
                    handlers["cancel"]();
                    break;
            }
        });

        return new Promise((resolve) => {
            let interaction_end = () => {
                $("#input_coordinates_area .invalid-feedback").hide();
                $input_coordinates_area.removeEventListener("shown.bs.modal", interaction_end);
                $input_coordinates_area.removeEventListener("hidden.bs.modal", interaction_end);
                $("body").off("click.input_coordinates_area.btn", "#input_coordinates_area .btn");
                $("body").off("keydown", "#input_coordinates_area");
                $("#input_coordinates_area input").off("focus blur keyup paste input");
                log.debug(`Interaction ended with N=${N}, E=${E}`);
                if (new_E === "" || new_N === "") {
                    resolve(null);
                }
                resolve({E: parseFloat(new_E), N: parseFloat(new_N)});
            };

            $input_coordinates_area.addEventListener("hidden.bs.modal", interaction_end);
            input_coordinates_area_modal.show();
        });
    };
};

export default new InputCoordinatesArea();
